import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useFeedbackStore } from '@/stores/feedback';
import { useWebportalStore } from '@/stores/webportal';
import { useOnlineStore } from '@/stores/online';
import { jwtDecode } from 'jwt-decode';
import { $ResetPinia } from '@/stores/ExtendedPinia';
import router from '@/router';

//Create axios instance using config.ts
const api = axios.create();


let extending: false | Promise<void> = false
async function checkLogin() {
    if (extending) {
        await extending;
    }
    const authStore = useAuthStore();
    const currentToken = useAuthStore().VLtoken;
    if (currentToken) {
        const token = jwtDecode(currentToken);
        if (token.iat && token.exp) {
            const issued: number = token.iat + 60*60;
            const expired: number = token.exp - 60*60;
            const current = Date.now().valueOf() / 1000;
            if ((current > issued || current > expired) && !extending && authStore.servicesToken != null) {
                // eslint-disable-next-line
                extending = new Promise((resolve, _reject) => {
                    const data = atob(authStore.servicesToken!);
                    axios.post(`${useWebportalStore().vlApiUrl}/auth/authenticate-webportal`, {
                        username: data.split(':')[0],
                        password: data.split(':')[1]
                    }).then((r) => {
                        useAuthStore().VLtoken = r.data.data;
                        localStorage.setItem('VlApiToken', r.data.data);
                
                        extending = false;
                        resolve();
                    }).catch(() => {
                        authStore.logout();
                        $ResetPinia();
                        router.push('/login');
                    });
                })
           }}
    }
}

api.interceptors.request.use(async (config) => {
    //Set loading to true
    useFeedbackStore().startLoading();

    await checkLogin();

    //Set authentication token in header if available
    const authStore = useAuthStore();
    const token = authStore.VLtoken;
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
},
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use((response) => {
    // Set feedbackStore.isLoading to false when a response is received
    const feedbackStore = useFeedbackStore();
    feedbackStore.stopLoading();

    // Return the response data
    return response;
}, (error) => {
    // Set feedbackStore.isLoading to false when an error response is received
    const feedbackStore = useFeedbackStore();
    const onlineStore = useOnlineStore();
    feedbackStore.stopLoading();

    // Check for specific error conditions
    if (error.response) {
        // The request was made, and the server responded with a status code that's in the 500 range
        if (error.response.status.toString().startsWith('5')) {
            feedbackStore.setTranslatedMessage('danger', 'basicError');
        }

    // The request was made, but no response was received or the user has no connection
    } else if (error.request && !onlineStore.sentNoConnectionMessage) {
        feedbackStore.setTranslatedMessage('danger', 'noConnectionError', 3000);
        onlineStore.sentNoConnectionMessage = true;
    }

    // Return the error response
    return Promise.reject(error);
});

export default api;